import React, {useState} from 'react';
import {Box, Grid, Popover, Typography} from '@mui/material';
import AurButton from '../aur-button/AurButton';
import {colorArray, DEFAULT_COLOR} from '../../../constants/constants';
import {t} from 'i18next';

export type AurColorPickerOptionsProp = {
  backgroundColor: string;
  textColor: string;
};

type AurColorPickerProps = {
  buttonType: 'text' | 'exit' | 'continue' | 'secondary' | 'submit';
  buttonLabel?: string;
  buttonSize?: 'Large' | 'Medium' | 'Small';
  ariaLabel?: string;
  disabled: boolean;
  setSelectedColor: (selectedColor: AurColorPickerOptionsProp) => void;
};

const AurColorPicker: React.FC<AurColorPickerProps> = (props) => {
  const {
    buttonType,
    buttonLabel,
    buttonSize,
    ariaLabel,
    disabled,
    setSelectedColor,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorSelect = (selectedColorProp: AurColorPickerOptionsProp) => {
    setSelectedColor(selectedColorProp);
    handleClose();
  };

  return (
    <Box>
      <AurButton
        type={buttonType}
        label={buttonLabel}
        size={buttonSize}
        ariaLabel={ariaLabel}
        onClick={handleClick}
        disabled={disabled}
      />
      <Popover
        className="aur-color-picker"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        slotProps={{
          paper: {
            role: 'dialog',
            'aria-label': t('common.colorPicker'),
          },
        }}
      >
        <Box className="aur-color-picker-box">
          <Grid container spacing={1} className="aur-color-picker-grid">
            {colorArray
              .filter((x) => x.backgroundColor != DEFAULT_COLOR)
              .map((color: AurColorPickerOptionsProp) => (
                <Grid item xs={2.4} key={color.backgroundColor}>
                  <Box
                    onClick={() => handleColorSelect(color)}
                    className="aur-color-picker-div"
                    sx={{
                      backgroundColor: color.backgroundColor,
                      color: color.textColor,
                    }}
                  >
                    <Typography className="typo-text label2_size aur-color-picker-div-content">
                      {t('common.a')}
                    </Typography>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Popover>
    </Box>
  );
};

export default AurColorPicker;
